import { Button, Dropdown } from "antd";
import React from "react";
import maruza_1 from "../fayl/maruza/1-maruza.pdf"
import maruza_2 from "../fayl/maruza/2-maruza.pdf"
import maruza_3 from "../fayl/maruza/3-maruza.pdf"
import maruza_4 from "../fayl/maruza/4-maruza.pdf"
import maruza_5 from "../fayl/maruza/5-maruza.pdf"
import maruza_6 from "../fayl/maruza/6-maruza.pdf"
import maruza_7 from "../fayl/maruza/7-maruza.pdf"
import maruza_8 from "../fayl/maruza/8-maruza.pdf"
import maruza_9 from "../fayl/maruza/9-maruza.pdf"
import maruza_10 from "../fayl/maruza/10-maruza.pdf"
import maruza_11 from "../fayl/maruza/11-maruza.pdf"
import maruza_12 from "../fayl/maruza/12-maruza.pdf"
import maruza_13 from "../fayl/maruza/13-maruza.pdf"
import maruza_14 from "../fayl/maruza/14-maruza.pdf"
import maruza_15 from "../fayl/maruza/15-maruza.pdf"


const items =[
    {
        key: '1',
        label: ( <a href={maruza_1}>1-ma`ruza matni</a> )
    },
    {
        key: '2',
        label: ( <a href={maruza_2}>2-ma`ruza matni</a> )
    },{
        key: '3',
        label: ( <a href={maruza_3}>3-ma`ruza matni</a> )
    },{
        key: '4',
        label: ( <a href={maruza_4}>4-ma`ruza matni</a> )
    },{
        key: '5',
        label: ( <a href={maruza_5}>5-ma`ruza matni</a> )
    },{
        key: '6',
        label: ( <a href={maruza_6}>6-ma`ruza matni</a> )
    },{
        key: '7',
        label: ( <a href={maruza_7}>7-ma`ruza matni</a> )
    },{
        key: '8',
        label: ( <a href={maruza_8}>8-ma`ruza matni</a> )
    },{
        key: '9',
        label: ( <a href={maruza_9}>9-ma`ruza matni</a> )
    },{
        key: '10',
        label: ( <a href={maruza_10}>10-ma`ruza matni</a> )
    },{
        key: '11',
        label: ( <a href={maruza_11}>11-ma`ruza matni</a> )
    },{
        key: '12',
        label: ( <a href={maruza_12}>12-ma`ruza matni</a> )
    },{
        key: '13',
        label: ( <a href={maruza_13}>13-ma`ruza matni</a> )
    },{
        key: '14',
        label: ( <a href={maruza_14}>14-ma`ruza matni</a> )
    },{
        key: '15',
        label: ( <a href={maruza_15}>15-ma`ruza matni</a> )
    }
]
const Maruza =() => {
    return (
    <Dropdown menu={{items}} placement="bottom" arrow={{pointAtCenter : true}}>
        <Button className="button">Ma'ruzalar matni</Button>
    </Dropdown>
    )
}
export default Maruza